module.exports = __webpack_public_path__ + "static/media/Investment.9535e101.svg";